export default __webpack_public_path__ + "static/media/logo.1617c9f0.jpg";